const resources = {
    new: 'New',
    beautyChallenges: '2 Beauty Challenges: Earn up to 1000 points'
};

module.exports = function getResource(label) {
    return resources[label];
};
